import React, { Component } from 'react';
import PageLoader from "../../atom/loader/pageLaoder";
import { connect } from 'react-redux';

class LogoutPage extends Component {
    componentDidMount() {
        let mainPath2 = `${process.env.REACT_APP_REPORT_MF_SERVER_PATH}`
        let newURL = `${mainPath2}ditauth/getauth?distype=MFLogout`;
        console.log(newURL, "newURL")
        window.location.href = newURL
    }

    render() {
        return (
            <PageLoader />
        );
    }
}

export default LogoutPage;
